var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTvSolvedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14 28.5C21.732 28.5 28 22.232 28 14.5C28 6.76801 21.732 0.5 14 0.5C6.26801 0.5 0 6.76801 0 14.5C0 22.232 6.26801 28.5 14 28.5Z",
    fill: "#9C27B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3033 19.4958C14.1383 19.5508 13.8541 19.5508 13.6891 19.4958C12.2591 19.0099 9.05078 16.9657 9.05078 13.5007C9.05078 11.9699 10.2791 10.7324 11.8008 10.7324C12.6991 10.7324 13.4966 11.1632 14.0008 11.8416C14.4958 11.1724 15.3024 10.7324 16.2008 10.7324C17.7224 10.7324 18.9508 11.9699 18.9508 13.5007C18.9508 16.9657 15.7424 19.0099 14.3033 19.4958Z",
    stroke: "#9C27B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 9.00065C5.52148 10.5315 4.83398 12.4382 4.83398 14.5007C4.83398 19.5607 8.94065 23.6673 14.0007 23.6673C19.0607 23.6673 23.1673 19.5607 23.1673 14.5007C23.1673 9.44065 19.0607 5.33398 14.0007 5.33398C12.6898 5.33398 11.434 5.60899 10.3065 6.11316",
    stroke: "#9C27B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvSolvedIcon);
export default __webpack_public_path__ + "static/media/tvSolvedIcon.6132c2598962e5d84af2cc30210ea52c.svg";
export { ForwardRef as ReactComponent };